import _ from 'lodash';
import axios from 'axios';
import React,{useLayoutEffect} from 'react';
import { useNavigate } from "react-router-dom";
import styles from './scss/slackthank.module.scss'

function SlackWaiting() {
let history = useNavigate();

const slackAccess= async()=> {
    console.log("slack acccess-----------");
    let windowSearch= window.location.search;
    console.log(windowSearch,"windowSearch-------------");
    let slackSecretCode =  new URLSearchParams(windowSearch).get("code");
    if(slackSecretCode) {
        // curl -F code=1234 -F client_id=3336676.569200954261 -F client_secret=ABCDEFGH https://slack.com/api/oauth.v2.access
        let payload ={
            code: slackSecretCode,
            client_id:'4854286449888.4828600015126',
            client_secret:'24558bfb05072cd5b1d70155d25099c1',
            redirect_uri: 'https://marketplace.worktual.co.uk/waitingPage'
        };
        let headers={
            'Content-Type' : 'application/x-www-form-urlencoded'
        };
        await axios.post('https://slack.com/api/oauth.v2.access',payload, {headers} ).then((resp)=>{
            // console.log("data slackInstalledToken",resp);
            if(resp.status === 200 && !_.isUndefined(resp.data.team)){
               axios.post(`https://urapi.worktual.co.uk/urauth/v1/token/slack_install_oauth`, resp.data).then((response)=>{
                // console.log("slack instaled user respi",response);
                if(response.data.statusCode === 200) { history('/slackthanks')}
               })
               .catch((err)=>{
                console.log("err",err)
               })
            }
        })
        .catch((err)=> {
            console.log("error",err)
        })
    }
}
useLayoutEffect(  ()=> {
    console.log("use layout effect---------");
    slackAccess()
},[])

    return (
        <div className={styles.thankuPage}>
            <h3>Please Wait......</h3> 
        </div>
    )
}
export {SlackWaiting};